module.exports = __webpack_public_path__ + "img/u26.1e3c3cd9.png";